import styled from "styled-components";
import PageTopTitle from "../../components/shared/PageTopTitle";
import useWindowDimensions from "../../hooks/useWindowSize";
import { useState } from "react";
import ProfilSifreVeGuvenlikContainer from "../../components/profilimContainer/profilBilgileriVeAyarlar/ProfilSifreVeGuvenlikContainer";
import DailyShipmentReportSettings from "../../components/profilimContainer/profilBilgileriVeAyarlar/DailyShipmentReportSettings";


const Container = styled.div`
  width: 100%;
  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    .profile-content{
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 30px;
        .tab-side{
            width: 300px;
            min-height: 50vh;
            border-right: 2px solid ${({theme}) => theme.mainBorderColor};
            padding-right: 50px;
            p{
                font-size: var(--font-size-lg);
                font-weight: var(--font-weight-lg);
                margin-bottom: 20px;
            }
            .side-list{
                display: flex;
                flex-direction: column;
                gap: 10px;
                .side-list-item{
                    padding: 10px 15px;
                    border-radius: 5px;
                    cursor: pointer;
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-lg);
                    background-color: ${({theme}) => theme.mainBgColor};
                }
                .active-menu{
                    background-color: ${({theme}) => theme.secondaryBgColor};
                    color: var(--color-main);
                }
            }
        }
    }
  }

  @media (max-width: 850px) {
    .wrapper .profile-content {
      flex-direction: column;
      gap: 24px;
      padding: 20px;

      .tab-side {
        width: 100%;
        min-height: auto;
        padding-right: 0;
        padding-bottom: 14px;
        border-right: 0;
        border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};

        .side-list {
          flex-direction: row;
          flex-wrap: wrap;
        }
      }
    }
  }
`;

const sideMenus = [
    {
        id: 1,
        title: "Şifre ve Güvenlik",
    },
    {
        id: 2,
        title: "Bildirim Ayarları",
    },
]

const Ayarlar = () => {

    const {windowDimensions} = useWindowDimensions()
    const [activeMenu, setActiveMenu] = useState(1)

    const handleMenuClick = (id) => {
        setActiveMenu(id)
    }

  return (
    <Container>
      <div className="wrapper">
        {
            windowDimensions.width > 850 &&
            <PageTopTitle title={"Ayarlar"} position="sticky" top="210px" />
        }

        <div className="profile-content">
            <div className="tab-side">
                {/* <p>Ayarlar</p> */}
                <div className="side-list">
                    {
                        sideMenus.map((item) => (
                            <div onClick={() => handleMenuClick(item.id)} className={`side-list-item ${activeMenu === item.id ? "active-menu" : ""}`} key={item.id}>
                                {item.title}
                            </div>
                        ))
                    }
                </div>
            </div>

            {activeMenu === 1 && <ProfilSifreVeGuvenlikContainer />}
            {activeMenu === 2 && <DailyShipmentReportSettings />}
        </div>
      </div>
    </Container>
  );
};

export default Ayarlar;
